import { isRequired, createValidator, combineValidators, notInArray, constants, isUrl } from 'app/validators/base'

export const validate = combineValidators(
  [
    isRequired(value => (typeof value === 'string' ? value.trim() : value)),
    notInArray([constants.IMAGE_TOO_SMALL, constants.WRONG_FILE_TYPE], value => value, {
      [constants.IMAGE_TOO_SMALL]: 'too small',
      [constants.WRONG_FILE_TYPE]: 'wrong type, file should be an image (.png, .jpg, .jpeg)',
    }),
    isUrl(value => value),
  ],
  true
)

export default createValidator(validate, 'image')
